import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanDeactivateGuard } from '@gp-angular/shared/guard';
import { BrowserModule } from '@angular/platform-browser';


const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('@gp-angular/api/booking').then(m => m.ApiBookingModule)
	}
];

@NgModule({
	imports: [
		BrowserModule,
		RouterModule.forRoot(routes, {initialNavigation: 'enabledBlocking', useHash: false,
			// In v15, relativeLinkResolution is not configurable in the Router. It was used to opt out of an earlier bug fix that is now standard
			// relativeLinkResolution: 'legacy'
		})
	],
	providers: [CanDeactivateGuard],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
